import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue';

import type { ObjectType } from '@/@types/graphql-types';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { FastOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import GridOffer from '@/features/buybox/components/grid/GridOffer.vue';
import { formatDateTime } from '@/helpers/date-helper';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'FastOffer',
  props: {
    title: null,
    offer: null,
    objectType: null
  },
  emits: ["clickOut"],
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	offer: FastOfferFragment;
	objectType: ObjectType;
};





const { language, country } = storeToRefs(useLanguageStore());
const isMounted = ref(false);

// Live status
const liveStatus = computed(() => {
	const now = new Date();
	return new Date(props.offer.availableFromTime) <= now && now < new Date(props.offer.availableToTime);
});

const dateOptions = {
	day: 'numeric',
	month: 'short',
} as const;

const timeOptions = {
	hour: 'numeric',
	minute: 'numeric',
} as const;

const USTimeZone = 'America/New_York';

onMounted(() => {
	isMounted.value = true;
});

const formattedDate = computed(() => {
	const options = isMounted.value ? dateOptions : { ...dateOptions, timeZone: USTimeZone };
	return formatDateTime(new Date(props.offer.availableFromTime), language.value, country.value, options);
});

const formattedTime = computed(() => {
	const options: Intl.DateTimeFormatOptions = isMounted.value
		? timeOptions
		: { ...timeOptions, timeZoneName: 'short', timeZone: USTimeZone };
	return formatDateTime(new Date(props.offer.availableFromTime), language.value, country.value, options);
});

return { __sfc: true,props, language, country, isMounted, liveStatus, dateOptions, timeOptions, USTimeZone, formattedDate, formattedTime, GridOffer }
}

})